module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/TV#1-94db94f210c23fbeb41646d46d7f1173.svg";